import LucideIcon from 'src/componentes/lucide-icon';

const obterTexto = (item, campo) =>
  (campo === 'responsavel' ? item?.responsavel?.nome : item?.descricao) || '';

const obterData = (item) =>
  item?.dataConclusao ? new Date(item.dataConclusao).getTime() : null;

export const alternarOrdenacao = (ordenacao, campo) => {
  if (ordenacao?.campo !== campo) return { campo, direcao: 'asc' };
  if (ordenacao.direcao === 'asc') return { campo, direcao: 'desc' };

  return null;
};

export const ordenarItensChecklist = (itens, ordenacao) => {
  if (!ordenacao?.campo || !itens?.length) return itens;

  const fator = ordenacao.direcao === 'asc' ? 1 : -1;

  return [...itens].sort((a, b) => {
    if (ordenacao.campo === 'data') {
      const dataA = obterData(a);
      const dataB = obterData(b);

      // itens sem data ficam sempre no fim, independente da direção
      if (dataA == null || dataB == null)
        return dataA === dataB ? 0 : dataA == null ? 1 : -1;

      return (dataA - dataB) * fator;
    }

    return (
      obterTexto(a, ordenacao.campo).localeCompare(
        obterTexto(b, ordenacao.campo),
        undefined,
        { sensitivity: 'base', numeric: true }
      ) * fator
    );
  });
};

export const CabecalhoColunaChecklist = ({
  rotulo,
  campo,
  ordenacao,
  style,
}) => {
  if (!ordenacao) return <div style={style}>{rotulo}</div>;

  const icone =
    ordenacao.campo !== campo
      ? 'ArrowUpDown'
      : ordenacao.direcao === 'asc'
        ? 'ChevronDown'
        : 'ChevronUp';

  return (
    <div
      className="d-flex align-items-center"
      style={{ ...style, cursor: 'pointer' }}
      onClick={() => ordenacao.aoOrdenar(campo)}
    >
      {rotulo}
      <LucideIcon
        icon={icone}
        size={14}
        className="ml-1"
        style={{ flexShrink: 0 }}
      />
    </div>
  );
};
